"use client";

import { memo } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import ImageWithFallback from "@/components/common/ImageWithFallback";

const OfferAlert = dynamic(() => import("./OfferAlert"));
const SpecialPriceBadge = dynamic(() =>
  import("@/components/common/card/SpecialPriceBadge"),
);

const MemoOfferAlert = memo(OfferAlert);

const LeftSection = ({
  t,
  info,
  imageTypes,
  handleLink,
  soldInPairs,
  surchargeItem,
  detailPageUrl,
  showOfferGroup,
}) => {
  return (
    <div className="lg:relative absolute lg:w-12/12 lg:max-w-[312px]">
      <Link prefetch={false} href={detailPageUrl}>
        <button
          type="button"
          onClick={handleLink}
          className="coverProductImage plp-coverProductImage absolute test"
        >
          <ImageWithFallback
            width={200}
            height={200}
            key={info?.sku}
            type={imageTypes.product}
            src={info?.thumbnail?.url}
            alt={info?.title_with_brand}
            className="w-12/12 h-auto aspect-[1/1] max-h-max"
          />
        </button>
      </Link>

      {showOfferGroup && (
        <div className="offers-group">
          {soldInPairs && <MemoOfferAlert text={t("sold_unit")} />}
          {surchargeItem && (
            <MemoOfferAlert
              text={t("product-listing:trade_text", {
                amount: surchargeItem,
              })}
            />
          )}
        </div>
      )}

      <div className="badge-img">
        {info?.best_seller == 1 && (
          <ImageWithFallback
            width={100}
            height={15.6}
            alt="Best seller"
            src={info?.bestseller_img}
            type={imageTypes.product_best_seller}
            className="w-auto xs:h-[22px] xs:max-h-[22px] h-4 max-h-4 object-contain object-left"
          />
        )}

        {info?.is_recommended == 1 && (
          <div className="verified-product">
            <ImageWithFallback
              width={100}
              height={15.6}
              alt="Recommended"
              src={info?.recommended_img}
              type={imageTypes.brand_recommended}
              className="max-h-[27px] object-contain"
            />
          </div>
        )}
      </div>

      {info?.showDiscountedPrice && (
        <SpecialPriceBadge showBadge price={info?.amountOff} />
      )}
    </div>
  );
};

export default LeftSection;
